export const buildDTOFromFlattenedManifest = (rootPredicateId, predicatesMap = {}) => {
    if (!predicatesMap?.[rootPredicateId]) return null;
    const manifest = { ...predicatesMap?.[rootPredicateId] };

    if (manifest?.predicates?.length) {
        manifest.predicates = manifest.predicates.map((predicateId) =>
            buildDTOFromFlattenedManifest(predicateId, predicatesMap)
        );
    }

    if (manifest?.predicateParts?.length) {
        manifest.predicateParts = manifest.predicateParts.map((predicatePartId) =>
            buildDTOFromFlattenedManifest(predicatePartId, predicatesMap)
        );
    }

    return manifest;
};
